import { Inject, Injectable } from '@angular/core';
import { WINDOW_TOKEN } from '../app/constants';

@Injectable()
export class EnvService {
  private stage: string;

  constructor(@Inject(WINDOW_TOKEN) private window: Window) {
    const location = this.window.location;
    const hostname = location.hostname;
    if (/^labelingtool-mtp/.test(hostname)) {
      this.stage = 'mtp';
    } else if (/^localhost/.test(hostname)) {
      this.stage = 'local';
    } else if (/^labelingtool/.test(hostname)) {
      this.stage = 'prod';
    } else {
      this.stage = null;
    }
  }

  getLoginUrl(): string {
    switch (this.stage) {
      case 'local':
        return 'https://labelingtool-backend.smartcat.ep.aws.it-hps.de/login';
      case 'mtp':
        return 'https://labelingtool-backend.smartcat.ep.aws.it-hps.de/login';
      case 'prod':
        return 'https://labelingtool-backend.smartcat.ep.aws.it-hps.de/login';
      default:
        throw new Error(`ERROR: Stage ${this.stage} not supported.`);
    }
  }

  getMetadataEndpoint() {
    if (window.location.href.includes('localhost')) {
      return '/labeling-results';
    }
    return 'https://labelingtool-backend.smartcat.ep.aws.it-hps.de/labeling-results';
  }
}
